/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteUserRequest
 */
export interface InviteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserRequest
     */
    permissions: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InviteUserRequest
     */
    administrator: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof InviteUserRequest
     */
    locations: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    inviterName: string;
    /**
     * 
     * @type {string}
     * @memberof InviteUserRequest
     */
    role: string;
}

/**
 * Check if a given object implements the InviteUserRequest interface.
 */
export function instanceOfInviteUserRequest(value: object): value is InviteUserRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('administrator' in value) || value['administrator'] === undefined) return false;
    if (!('locations' in value) || value['locations'] === undefined) return false;
    if (!('inviterName' in value) || value['inviterName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function InviteUserRequestFromJSON(json: any): InviteUserRequest {
    return InviteUserRequestFromJSONTyped(json, false);
}

export function InviteUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'permissions': json['permissions'],
        'administrator': json['administrator'],
        'locations': json['locations'],
        'inviterName': json['inviterName'],
        'role': json['role'],
    };
}

export function InviteUserRequestToJSON(json: any): InviteUserRequest {
    return InviteUserRequestToJSONTyped(json, false);
}

export function InviteUserRequestToJSONTyped(value?: InviteUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'permissions': value['permissions'],
        'administrator': value['administrator'],
        'locations': value['locations'],
        'inviterName': value['inviterName'],
        'role': value['role'],
    };
}

